import React, { memo } from "react";
import { Button } from "@mui/material";
import { Alignment, Variant } from "../types";
import clsx from "clsx";
import "./styles.scss";

type Color = "primary" | "secondary";

export interface ButtonComponentProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  id?: string;
  label?: string;
  fullWidth?: boolean;
  color?: Color;
  variant?: Variant;
  roundBorder?: boolean;
  disabled?: boolean;
  customStyles?: string;
  align?: Alignment;
}

export const SubmitButton: React.FC<ButtonComponentProps> = ({
  onClick,
  id,
  label = "Test Button",
  fullWidth = false,
  roundBorder = false,
  disabled = false,
  align = "left",
  variant = "outlined",
  customStyles,
  ...otherProps
}: ButtonComponentProps) => {
  return (
    <Button
      type='submit'
      className={clsx("btn_submit_primary", customStyles)}
      onClick={onClick}
      id={id}
      disabled={disabled}
      fullWidth={fullWidth}
      variant={variant}
      {...otherProps}
    >
      {label}
    </Button>
  );
};

export default memo(SubmitButton);
